module.exports = __webpack_public_path__ + "img/logo.374cfdd2.png";